import React, { useState } from "react";
import styles from "./ExamCorner.module.css";

const ExamCorner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    answerSheet: null
  });
  const [fileName, setFileName] = useState("");

  // Exam data
  const exams = [
    {
      id: 1,
      title: "UPSC Mathematics Optional - 2026",
      date: "March 25, 2026",
      time: "10:00 AM - 1:00 PM",
      duration: "3 hours",
      totalMarks: 250,
      questions: 8,
      type: "Descriptive",
      hasSubmitPaper: true, // Has submit paper option
      attemptLink: "https://example.com/upsc-maths-2026-exam", // Replace with actual link
      color: "#0B5E42"
    },
    {
      id: 2,
      title: "UPSC Mathematics Optional - 2027",
      date: "April 15, 2027",
      time: "10:00 AM - 1:00 PM",
      duration: "3 hours",
      totalMarks: 250,
      questions: 8,
      type: "Descriptive",
      hasSubmitPaper: true, // Has submit paper option
      attemptLink: "https://example.com/upsc-maths-2027-exam", // Replace with actual link
      color: "#2563EB"
    },
    {
      id: 3,
      title: "BPSC Mathematics Optional",
      date: "March 30, 2026",
      time: "10:00 AM - 1:00 PM",
      duration: "3 hours",
      totalMarks: 200,
      questions: 10,
      type: "MCQ Based",
      hasSubmitPaper: false, // No submit paper option for MCQ exam
      attemptLink: "https://example.com/bpsc-maths-exam", // Replace with actual link
      color: "#8B5CF6"
    }
  ];

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file size (5MB = 5 * 1024 * 1024 bytes)
      if (file.size > 5 * 1024 * 1024) {
        alert("File size exceeds 5MB. Please upload a smaller file.");
        e.target.value = null;
        return;
      }
      
      // Check file type (allow images and PDFs)
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        alert("Please upload only JPG, PNG, or PDF files.");
        e.target.value = null;
        return;
      }

      setFormData({
        ...formData,
        answerSheet: file
      });
      setFileName(file.name);
    }
  };

  // Open modal for selected exam
  const openSubmitModal = (exam) => {
    setSelectedExam(exam);
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedExam(null);
    setFormData({
      name: "",
      mobile: "",
      email: "",
      answerSheet: null
    });
    setFileName("");
    document.body.style.overflow = "auto";
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.name || !formData.mobile || !formData.email || !formData.answerSheet) {
      alert("Please fill all fields and upload answer sheet");
      return;
    }

    // Validate mobile number (10 digits)
    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email address");
      return;
    }

    // Here you would typically send the data to your backend
    console.log("Form submitted:", {
      exam: selectedExam?.title,
      ...formData,
      answerSheet: formData.answerSheet.name
    });

    alert(`Answer sheet for ${selectedExam?.title} submitted successfully!`);
    closeModal();
  };

  // Handle attempt now
  const handleAttemptNow = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div className={styles.examCorner}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.container}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>
              <span className={styles.gradientText}>Exam Corner</span>
            </h1>
            <p className={styles.heroSubtitle}>
              Practice with real exam patterns. Attempt tests and submit your answers for evaluation.
            </p>
          </div>
        </div>
      </section>

      {/* Exams List - Stacked Vertically */}
      <section className={styles.examsSection}>
        <div className={styles.container}>
          <div className={styles.examsList}>
            {exams.map((exam) => (
              <div key={exam.id} className={styles.examCard}>
                <div className={styles.examCardHeader} style={{ borderLeftColor: exam.color }}>
                  <div className={styles.examType} style={{ background: exam.color }}>
                    {exam.type}
                  </div>
                </div>

                <div className={styles.examCardBody}>
                  <h3>{exam.title}</h3>
                  
                  <div className={styles.examDetails}>
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>Exam Date:</span>
                      <span className={styles.detailValue}>{exam.date}</span>
                    </div>
                    
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>Time:</span>
                      <span className={styles.detailValue}>{exam.time}</span>
                    </div>
                    
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>Duration:</span>
                      <span className={styles.detailValue}>{exam.duration}</span>
                    </div>
                    
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>Total Marks:</span>
                      <span className={styles.detailValue}>{exam.totalMarks}</span>
                    </div>
                    
                    <div className={styles.detailItem}>
                      <span className={styles.detailLabel}>Questions:</span>
                      <span className={styles.detailValue}>{exam.questions}</span>
                    </div>
                  </div>

                  <div className={styles.examActions}>
                    <button 
                      className={styles.attemptBtn}
                      style={{ background: exam.color }}
                      onClick={() => handleAttemptNow(exam.attemptLink)}
                    >
                      <i className="fas fa-play-circle"></i>
                      Attempt {exam.type === "MCQ Based" ? "MCQ Now" : "Now"}
                    </button>
                    
                    {/* Only show Submit Paper button for exams that have it */}
                    {exam.hasSubmitPaper && (
                      <button 
                        className={styles.submitBtn}
                        style={{ borderColor: exam.color, color: exam.color }}
                        onClick={() => openSubmitModal(exam)}
                      >
                        <i className="fas fa-upload"></i>
                        Submit Paper
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instructions Section */}
      <section className={styles.instructionsSection}>
        <div className={styles.container}>
          <div className={styles.instructionsCard}>
            <h2>Important Instructions</h2>
            <div className={styles.instructionsGrid}>
              <div className={styles.instructionItem}>
                <i className="fas fa-clock"></i>
                <p>Complete the exam within the given duration</p>
              </div>
              <div className={styles.instructionItem}>
                <i className="fas fa-file-pdf"></i>
                <p>Upload answer sheet in PDF, JPG, or PNG format only</p>
              </div>
              <div className={styles.instructionItem}>
                <i className="fas fa-database"></i>
                <p>Maximum file size: 5MB</p>
              </div>
              <div className={styles.instructionItem}>
                <i className="fas fa-mobile-alt"></i>
                <p>Keep your registered mobile number handy</p>
              </div>
              <div className={styles.instructionItem}>
                <i className="fas fa-envelope"></i>
                <p>You will receive evaluation results on email</p>
              </div>
              <div className={styles.instructionItem}>
                <i className="fas fa-check-circle"></i>
                <p>Submit only one answer sheet per exam</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Submit Paper Modal */}
      {isModalOpen && selectedExam && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeModalBtn} onClick={closeModal}>
              <i className="fas fa-times"></i>
            </button>
            
            <div className={styles.modalHeader}>
              <h2>Submit Answer Sheet</h2>
              <p className={styles.modalExamTitle}>{selectedExam.title}</p>
            </div>

            <form onSubmit={handleSubmit} className={styles.submitForm}>
              <div className={styles.formGroup}>
                <label htmlFor="name">
                  <i className="fas fa-user"></i>
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="mobile">
                  <i className="fas fa-phone"></i>
                  Mobile Number *
                </label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  placeholder="10-digit mobile number"
                  maxLength="10"
                  pattern="[0-9]{10}"
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="email">
                  <i className="fas fa-envelope"></i>
                  Email ID *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email address"
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="answerSheet">
                  <i className="fas fa-file-upload"></i>
                  Upload Answer Sheet *
                </label>
                <div className={styles.fileUploadArea}>
                  <input
                    type="file"
                    id="answerSheet"
                    name="answerSheet"
                    onChange={handleFileChange}
                    accept=".jpg,.jpeg,.png,.pdf"
                    required
                  />
                  <div className={styles.fileUploadPlaceholder}>
                    <i className="fas fa-cloud-upload-alt"></i>
                    <p>{fileName || "Click to upload or drag and drop"}</p>
                    <span>PDF, JPG, PNG (Max 5MB)</span>
                  </div>
                </div>
              </div>

              <div className={styles.formFooter}>
                <button type="button" className={styles.cancelBtn} onClick={closeModal}>
                  Cancel
                </button>
                <button type="submit" className={styles.submitFormBtn} style={{ background: selectedExam.color }}>
                  <i className="fas fa-paper-plane"></i>
                  Submit Paper
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExamCorner;